import React, {FunctionComponent} from "react";
import FlexContent, {FlexContentDirection, FlexContentSpacing} from "../flex-content/FlexContent";

export type FormLayoutRowsProps = {
    children: React.ReactNode;
    spacing?: FlexContentSpacing;
    inline?: boolean;
    cssClass?: string;
};

const FormLayoutRows: FunctionComponent<FormLayoutRowsProps> = ({children, spacing = FlexContentSpacing.LARGE, inline, cssClass}) => {
    const childrenList = (Array.isArray(children) ? children : [children]).filter((it) => !!it);

    if (!childrenList.length) {
        return <></>;
    }

    return (
        <FlexContent
            direction={FlexContentDirection.COLUMN}
            spacing={spacing}
            cssClass={cssClass}
        >
            {childrenList.map((element, index) =>
                <React.Fragment key={`element-${index.toString()}`}>
                    {inline ? React.cloneElement(element as React.ReactElement, {inline}) : element}
                </React.Fragment>
            )}
        </FlexContent>
    );
};

export default FormLayoutRows;
